import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../modules/user/services/user.service";
import Swal from "sweetalert2";
import { environment } from "../../../../environments/environment";
import { CTranslateService } from "../../../core/pipes/c-translate/c-translate.service";
import { HomeComponent } from "../../../modules/home/components/dashboard/home.component";

@Component({
    selector: 'app-register-public',
    templateUrl: './register-page.component.html'
})
export class RegisterPageComponent implements OnInit {
    constructor(protected toastr: ToastrService,
                protected route: ActivatedRoute,
                protected _modalService: NgbModal,
                protected userService: UserService,
                protected translateService: CTranslateService,
                protected router: Router) {
    }
    
    showPassword = false;
    groupReferralName = null;
    appStoreLink = 'https://apps.apple.com/no/app/cameralla-go/id1624512415?l=nb&amp;kuid=5b729825-91d7-4708-b163-fb75d991d919&amp;kref=f8Baj5q0TgoQ';
    playStoreLink = 'https://play.google.com/store/apps/details?id=com.contemi.cameralla&amp;kuid=5b729825-91d7-4708-b163-fb75d991d919&amp;kref=f8Baj5q0TgoQ';
    groupReferralBanner = null;
    groupReferralMobileBanner = null;
    loginLink = environment['site']  +  'wp-login.php'
    @ViewChild('passwordField') passwordInput: ElementRef;
    user:any = {
        email : "",
        phone : "",
        phoneCountryCode : "+47",
        firstName : "",
        lastName : "",
        password : "",
        preferredLanguage : "no",
        referralId: null,
        referralGroupId: null,
        acceptNewLetters: false,
        onboardType: 'web'
    }
    
    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }
    
    chooseCountryCode(countryCode) {
        this.user.phoneCountryCode =  '+' + countryCode;
    }
    
    codeCountryConst =['213','376','244','1264','1268','54','374','297','61','43','994','1242','973','880',
        '1246','375','32','501','229','1441','975','591','387','267','55','673','359','226','257','855','237','1','238',
        '1345','236','56','86','57','269','242','682','506','385','53','90392','357','42','45','253','1809','1809','593',
        '20','503','240','291','372','251','500','298','679','358','33','594','689','241','220','7880','49','233','350',
        '30','299','1473','590','671','502','224','245','592','509','504','852','36','354','91','62','98','964','353',
        '972','39','1876','81','962','7','254','686','850','82','965','996','856','371','961','266','231','218','417',
        '370','352','853','389','261','265','60','960','223','356','692','596','222','269','52','691','373','377','976',
        '1664','212','258','95','264','674','977','31','687','64','505','227','234','683','672','670','47','968','680',
        '507','675','595','51','63','48','351','1787','974','262','40','7','250','378','239','966','221','381','248','232','65','421','386','677','252','27','34','94','290','1869','1758','249','597','268','46','41','963','886','7','66','228','676','1868','216','90','7','993','1649','688','256','44','380','971','598','1','7','678','379','58','84','84','84','681','969','967','260','263']
    
    ngOnInit() {
        this.user.referralGroupId = this.route.snapshot.queryParamMap.get('groupReferralId');
        this.user.referralId = this.route.snapshot.queryParamMap.get('referralId');
        this.groupReferralName = this.route.snapshot.queryParamMap.get('groupReferralName');
        if (this.user.referralGroupId == 88) { //TODO for another partners
            this.appStoreLink = 'https://oqb09.app.link/ZsMrlxj90Jb';
            this.playStoreLink = 'https://oqb09.app.link/ZsMrlxj90Jb';
            this.groupReferralBanner = 'https://camerallaphoto.com/banner/86qig1706025429340.png';
            this.groupReferralMobileBanner = './assets/images/foto-club.png';
        }
    }
    
    public checkSizeWindowMobile() {
        return screen.width <= HomeComponent.maxWidthMobile;
    }
    
    createUser() {
        this.userService.createUser(this.user).subscribe(() => {
            Swal.fire({
                title: this.translateService.translate('SIGN_UP_SUCCESSFULLY'),
                text: this.translateService.translate('GUIDE_AFTER_SIGN_UP'),
            }).then((result) => {
                Swal.fire({
                    title: this.translateService.translate('SIGN_UP_SUCCESSFULLY'),
                    text: this.translateService.translate('REDIRECT_LOGIN_PAGE_NOTI'),
                })
                window.location.href = this.loginLink;
            })
        })
    }
    
    changeLanguage(lang) {
        this.translateService.setLang(lang);
        window.location.reload();
    }
    
}

